/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_DescriptionInputs */

const he_footer_description = /** @type {(inputs: Footer_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הוא שרות חינמי המסייע לכם לחסוך כסף בקניות ברשת בעזרת כלי מעקב היסטוריית מחירים.`)
};

const en_footer_description = /** @type {(inputs: Footer_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`is a free service that helps you save money on online shopping with price history tracking tools.`)
};

/**
* | output |
* | --- |
* | "is a free service that helps you save money on online shopping with price history tracking tools." |
*
* @param {Footer_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_description = /** @type {((inputs?: Footer_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_footer_description(inputs)
	return en_footer_description(inputs)
});